<template>
  <div class="container">
    <!-- Decorative floating hearts -->
    <div class="floating-hearts">
      <HeartComponent v-for="n in heartCount" :key="n" class="floating-heart" :style="getHeartStyle()" />
    </div>

    <h1 class="title">Our Love Story</h1>
    <div class="date-container">
      <HeartComponent />
      <p class="days">我们在一起已经{{ days }}天了！</p>
      <HeartComponent />
    </div>
    <FireWorkComponent class="firework" />
  </div>
</template>

<script>
import HeartComponent from './HeartComponent.vue';
import FireWorkComponent from './FireWorkComponent.vue';

export default {
  name: 'DateComponent',
  components: {
    HeartComponent,
    FireWorkComponent,
  },
  data() {
    return {
      form: {
        date: '2023-02-04',
      },
      days: null,
      screenWidth: window.innerWidth,
    };
  },
  computed: {
    heartCount() {
      // Return more hearts on smaller screens for a denser effect
      return this.screenWidth <= 768 ? 25 : 15;
    },
  },
  methods: {
    getHeartStyle() {
      const size = Math.random() * 30 + 10;
      const duration = Math.random() * 15 + 10;
      const delay = Math.random() * 10;
      const left = Math.random() * 100;
      return {
        width: `${size}px`,
        height: `${size}px`,
        left: `${left}%`,
        animationDuration: `${duration}s`,
        animationDelay: `${delay}s`,
      };
    },
    handleResize() {
      this.screenWidth = window.innerWidth;
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    const today = new Date();
    const selectedDate = new Date(this.form.date);
    const timeDiff = Math.abs(selectedDate.getTime() - today.getTime());
    const days = Math.floor(timeDiff / (1000 * 3600 * 24));
    this.days = days;
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* justify-content: center; */ /* Removed to allow specific padding-top */
  text-align: center;
  padding-top: 33vh; /* Position at top 1/3 of screen */
  height: 80vh;
  overflow: hidden;
  position: relative;
}

.title {
  font-size: 4rem;
  font-weight: bold;
  color: #ff69b4;
  text-shadow: 0 0 10px #ff69b4, 0 0 20px #ff69b4, 0 0 30px #ff69b4, 0 0 40px #ff69b4;
  margin-bottom: 20px;
  z-index: 1;
}

.date-container {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  color: white;
  margin-bottom: 20px;
  z-index: 1;
}

.days {
  margin: 0 20px;
}

div {
    color: white;
}

.firework {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
}

/* Floating hearts animation */
.floating-hearts {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  overflow: hidden;
}

.floating-heart {
  position: absolute;
  bottom: -50px; /* Start from below the screen */
  opacity: 0;
  animation-name: floatUp;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}

@keyframes floatUp {
  0% {
    transform: translateY(0);
    opacity: 0.7;
  }
  100% {
    transform: translateY(-100vh);
    opacity: 0;
  }
}

/* Media Query for Mobile Devices */
@media (max-width: 768px) {
  .title {
    font-size: 2.5rem;
  }
  .days {
    font-size: 1.2rem;
  }
  .date-container {
    font-size: 1.5rem;
  }
}
</style>
